var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},_vm._l((_vm.promoItems),function(promoItem){return _c('PromoBox',{key:promoItem.id,attrs:{"prop-item":promoItem}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }